import { useEffect } from 'react';
import { deals } from '../data/products';
import { useCart } from '../context/CartContext';
import { useCountdown } from '../hooks/useCountdown';
import './Deals.css';

export default function Deals() {
  const { addToCart } = useCart();
  const { h, m, s } = useCountdown(23 * 3600 + 47 * 60 + 59);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="wrapper deals-page">
      <div className="container">
        <div className="deals-page-hero reveal">
          <p className="sec-label">🔥 Limited Time</p>
          <h1 className="sec-h2 page-h1">Hot Deals</h1>
          <p className="sec-sub">Massive savings on top-tier tech. While stocks last — WhatsApp Last directly for fastest order processing!</p>
          <div className="deals-countdown reveal">
            <span className="cd-intro">Flash sale ends in:</span>
            {[{v:h,l:'Hours'},{v:m,l:'Mins'},{v:s,l:'Secs'}].map(({v,l}) => (
              <div key={l} className="cd-item">
                <span className="cd-num">{v}</span>
                <div className="cd-label">{l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="deals-grid-full reveal">
          {deals.map(d => (
            <div key={d.id} className="deal-card-lg">
              <div className="deal-card-img">{d.emoji}</div>
              <div className="deal-card-body">
                <div className="deal-brand">{d.brand}</div>
                <div className="deal-name">{d.name}</div>
                <p className="deal-desc">{d.desc}</p>
                <div className="deal-price-row">
                  <span className="deal-price">${d.price}</span>
                  <span className="deal-old">${d.oldPrice}</span>
                  <span className="deal-save">SAVE {d.save}</span>
                </div>
                <div className="deal-stock">
                  <div className="stock-bar"><div className="stock-fill" style={{width:`${d.stock}%`}} /></div>
                  <span className="stock-text">Only {d.stock}% left — {Math.round((100-d.stock) * 0.3)} units sold today</span>
                </div>
                <div className="deal-actions">
                  <button className="btn btn-cyan" onClick={() => addToCart(d)}>🛒 Add to Cart</button>
                  <a href={`https://wa.me/263713508064?text=Hi%20Last!%20I%20want%20the%20${encodeURIComponent(d.name)}`} target="_blank" rel="noreferrer" className="btn btn-wa">📱 Order on WhatsApp</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
